import { css } from '../../../styled-components';
import { mgbStyles } from './button.styles.mgb';
export const famigrosStyles = css`
  ${mgbStyles}

  border-radius: 28px;
  color: ${({
  theme: {
    colors
  }
}) => colors.tints.black[90]};
  letter-spacing: 0.3px;
  padding: 8px 20px;

  &:hover {
    color: ${({
  theme: {
    colors
  }
}) => colors.tints.black[90]};
  }

  &:focus {
    color: ${({
  theme: {
    colors
  }
}) => colors.tints.black[90]};
  }
`;